<template>
  <div class="store-visitors">

    <v-progress-circular  :indeterminate="loading"
                         :rotate="-90"
                         :size="size"
                         :width="16"
                         :value="getVisitorsValue"
                         :color="adjustedColor">
      <div class="progress-inner">
        <div class="inner-visitors">
          <!-- {{currently_in_store}} -->
          {{this.currently_in_store_temp}}
        </div>
        <div class="inner-text">
          Visitors in Store
        </div>
        <div class="inner-max">
          <!-- {{expired}} Expired -->
          {{0}} Expired
        </div>
        <div class="inner-max">
          {{store.num_persons}} Max
        </div>

        <v-btn large icon color="primary ">
          <v-icon large color="primary" @click="emitRefresh"> refresh</v-icon>
        </v-btn>

      </div>
    </v-progress-circular>
  </div>
</template>

<script>
  export default {
    name: "StoreVisitorsCircular",
    props: ['store', 'currently_in_store', 'loading', 'expired', 'size'],
  data: () => ({
    currently_in_store_temp: 1,
  }),
    computed: {
      adjustedColor() {
        return this.getVisitorsValue > 100 ? 'error' : '#76CD79'
      },
      getVisitorsValue() {
        let max_visitors = this.store.num_persons
        // let current_visitors = this.currently_in_store
        let current_visitors = this.currently_in_store_temp
        return 100 * current_visitors / max_visitors
      },
    },

    methods: {

      emitRefresh() {
        this.$emit('refresh')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .store-visitors {
    align-self: center;

    .progress-inner {
      text-align: center;
      color: #1565C0 !important;

      .inner-visitors {
        line-height: 28px;
        font-size: 36px;
        font-weight: 600;
      }

      .inner-text {
        font-size: 14px;
        font-weight: 600;
      }

      .inner-max {
        font-size: 14px;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/Elements/StoreVisitorsCircular.vue